<template>
  <el-alert
    v-if="failed"
    type="error"
    id="instance-task"
    title="An operation failed on this instance and did not complete successfully."
    :closable="false"
    show-icon
  >
    <el-button
      type="danger"
      size="mini"
      icon="mdi mdi-refresh"
      @click.prevent="retry"
    >
      Try again
    </el-button>

    <el-button type="text" size="mini">
      or contact support
    </el-button>
  </el-alert>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    instance: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    failed () {
      return this.tasks.find((t) => t.instanceId === this.instance.id && t.exitCode && t.running !== '1')
    },
    ...mapState(['tasks'])
  },
  methods: {
    retry () {
      this.$store.dispatch('restartTask', this.failed.id)
        .then(() => this.$notify({
          title: 'Put back in the queue',
          message: 'Thank you for your patience',
          type: 'success'
        }))
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .el-alert {
    position: relative;
    font-size: 9px;
    width: 100%;
    margin: 0 !important;
    border-bottom: 1px solid $--border-color-base;

    .el-button--text {
      color: $--color-danger;
    }
  }
</style>

<style lang="scss">
  #instance-task {
    .el-alert__description {
      position: absolute;
      right: 24px;
      top: 3px;
    }
  }
</style>
